import React, { useState } from "react";
import Button from "./components/Button";
import { UploadCloud, Info } from "lucide-react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DocumentComparison = () => {
  const [originalFile, setOriginalFile] = useState(null);
  const [editedFile, setEditedFile] = useState(null);
  const [downloadLinks, setDownloadLinks] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const formatText = (text) => {
    text = text.replace(/\n/g, "<div style='margin-top:33px'></div>").replace(/\t/g, "&emsp;&emsp;");
    text = text.replace(/<DEL>(.*?)<\/DEL>/g, '<span style="color:red; text-decoration:line-through;">$1</span>')
               .replace(/<ADD>(.*?)<\/ADD>/g, '<span style="color:green;">$1</span>');

    text = text.replace(/<table>[\s\S]*?<\/table>/g, (match) => {
      return match.replace(/\n/g, "").replace(/\s{2,}/g, "").trim();
    });

    return text;
  };

  // const formatText = (text) => {
  //   text = text.replace(/\n{2,}/g, "");
  //   text = text.replace(/(<br\/?>(\s*)?){2,}/g, "\n");
  //   text = text.replace(/\n/g, "<br/>").replace(/\t/g, "&emsp;&emsp;");
  //   text = text.replace(/<DEL>(.*?)<\/DEL>/g, '<span style="color:red; text-decoration:line-through;">$1</span>')
  //              .replace(/<ADD>(.*?)<\/ADD>/g, '<span style="color:green;">$1</span>');
  //   text = text.replace(/<table>[\s\S]*?<\/table>/g, (match) => {
  //     return match.replace(/\n/g, "").replace(/\s{2,}/g, "").trim();
  //   });
  //   return text;
  // };

  const handleSubmit = async () => {
    if (!originalFile || !editedFile) {
      toast.error("Please select both files before comparing.");
      return;
    }
    setLoading(true);
    toast.info("Processing files...");

    const formData = new FormData();
    formData.append("original", originalFile);
    formData.append("edited", editedFile);

    try {
      const response = await axios.post("https://aidocv2.onrender.com/compare", formData);
      setDownloadLinks(formatText(response.data.result));
      toast.success("Comparison completed successfully!");
    } catch (error) {
      console.error("Error processing files:", error);
      toast.error("Failed to process files. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (event, setFile) => {
    setFile(event.target.files[0]);
    toast.success(`File selected: ${event.target.files[0].name}`);
  };

  return (
    <div className="flex flex-row items-left justify-center min-h-screen bg-gray-900 p-5">
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar closeOnClick />

      <div className="bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-lg w-[400px] flex flex-col items-center border border-white/20 mr-4">
        <div className="flex items-center gap-2">
          <h2 className="text-2xl font-bold text-white mb-6">AI DOC Comparison</h2>
          <Info 
            className="text-white cursor-pointer mb-3" 
            size={24} 
            onClick={() => setShowPopup(true)} 
          />
        </div>

        <div className="flex flex-col items-center gap-4 w-full">
          <label className="flex flex-col items-center w-full p-6 bg-white/20 rounded-lg border border-dashed border-white/40 cursor-pointer">
            <UploadCloud size={32} className="text-white mb-2" />
            <span className="text-white">Click to Upload Original Doc</span>
            <input type="file" className="hidden" onChange={(e) => handleFileChange(e, setOriginalFile)} />
          </label>
          <label className="flex flex-col items-center w-full p-6 bg-white/20 rounded-lg border border-dashed border-white/40 cursor-pointer">
            <UploadCloud size={32} className="text-white mb-2" />
            <span className="text-white">Click to Upload Edited Doc</span>
            <input type="file" className="hidden" onChange={(e) => handleFileChange(e, setEditedFile)} />
          </label>
        </div>
        <Button onClick={handleSubmit} className="mt-6 bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-lg shadow-md">
          Compare
        </Button>
      </div>

      <div className="bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-lg w-[1000px] flex flex-col items-left border border-white/20 text-white">
        {loading ? (
          <div className="flex items-center justify-center">
            <div className="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          downloadLinks && (
            <div className="text-left">
              <div dangerouslySetInnerHTML={{ __html: downloadLinks }} />
            </div>
          )
        )}
      </div>

      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg w-500 text-white relative">
            <h3 className="text-xl font-bold mb-4">Project Details</h3>
            <p><strong>Front end:</strong> React JS</p>
            <p><strong>Back end:</strong> Python</p>
            <p><strong>AI Model:</strong> qwen-2.5-32b</p>
            <p><strong>Inference:</strong> Groq</p>
            <p><strong>API:</strong> Hosted in render (third-party testing server)</p>
            <button 
              className="absolute top-2 right-2 text-gray-300 hover:text-white" 
              onClick={() => setShowPopup(false)}>
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentComparison;
